import { createContext } from 'react';

export const JurorContext = createContext(null);
